export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/Block3_Mobile-65ac2fa9cee08345a390a8333014bb95.png";